import React from "react";
import TopToolbar from "../../global/subcomponents/topToolbar/TopToolbar";
import { Layout } from "../../global/Table/TablePageHelpers/LayoutObject";
import { TableCell, Select, MenuItem, FormControl, InputLabel, Box } from "@mui/material";
import TablePage from "../../global/Table/TablePage";
import '../shippingSummary/ShippingSummary.css';
import { HourglassEmptyTwoTone } from '@material-ui/icons';
import { JOURNAL, JOURNAL_ENTRY, JOURNAL_ENTRY_FIELDS, JOURNAL_ENTRY_PAGES } from './constants';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import TwoStepDelete from '../../global/subcomponents/twoStepDelete/TwoStepDelete';
import { IconButton } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';
import EditIcon from '@material-ui/icons/Edit';
import * as XLSX from 'xlsx';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { format } from 'date-fns';

class JournalEntryTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      deleteId: "",
      isDeleted: false,
    }
  }

   formatDate = (date) => {
        try {
            const parsedDate = new Date(date);
            if (isNaN(parsedDate)) {
                throw new Error('Invalid Date');
            }
            return format(parsedDate, 'yyyy-MM-dd');
        } catch (e) {
            return date;
        }
  };

  getTableHeaders = () => {
    let headers = [];
    headers.push(Layout.columnHead(null,null,null))
    JOURNAL_ENTRY_FIELDS.forEach((headCell) => {
      headers.push(Layout.columnHead(headCell.label, headCell.id, 'left'));
    });
    return headers;
  };

  formatDollar = (amount) => {
    if (amount === null || amount === undefined) {
      amount = 0;
    }

    const amountStr = parseFloat(amount).toFixed(2).toString();

    // Check if amountStr is NaN after parsing
    if (isNaN(amountStr)) {
      return '';
    } else {
      return (
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            gap: '3px',
            marginRight: '15px',
          }}
        >
          <span
            style={{ flexShrink: 0, marginLeft: '16px', marginRight: '16px' }}
          >
            $
          </span>
          <span style={{ marginLeft: 'auto' }}>
            {amountStr.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
          </span>
        </div>
      );
    }
  };

  tableRow = (data) => {
    return (
      <React.Fragment>

        <TableCell>
          <Tooltip title={"Edit Journal Entry"}>
            <IconButton
              onClick={() => {
                  this.props.setCurrentPage(JOURNAL_ENTRY_PAGES.EDIT, data);
              }}
            >
              <EditIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </TableCell>

        <TableCell
          style={{
            width: '10%',
            paddingLeft:'30px',
            paddingRight:'30px'
          }}
        >
         {this.formatDate(data.journalEntryDate)}
        </TableCell>
        <TableCell
                   style={{
                     width: '55%',
                     paddingLeft:'28px',
                   }}
        >
          {data?.journalEntryDescription}
        </TableCell>
        <TableCell
                   style={{
                     width: '18%',
                     paddingLeft:'8px',
                   }}
        >
          {this.formatDollar(data?.amount)}
        </TableCell>


        <TwoStepDelete
          style={{
            width: '10%',
            paddingLeft:'8px',
          }}
          rowId={data.journalEntryId}
          handleDelete={(rowIdToDelete) => {
            const request = {
              journalEntryId: data.journalEntryId,
              // year: this.props.year,
              // currency: this.props.currency,
            };

            this.props.deleteJournalEntry(request);

            this.setState({
              isDeleted: true,
              deleteId: '',
            });
          }}
          type={this.state.isDeleted}
          deleteId={this.state.deleteId}
          setDeleteId={(newDeleteId) =>
            this.setState({ deleteId: newDeleteId })
          }
        />


      </React.Fragment>
    );
  };

  searchStrings = (data) => {
    return [data.journalEntryDescription, data.journalEntryDate];
  };

  handleExport = () => {
    const { allJournalEntries } = this.props;
    const workbook = XLSX.utils.book_new();

    const formatAmount = (amount) => {
      const num = parseFloat(amount);
      return isNaN(num) || num === 0 ? '' : Number(num.toFixed(2));
    };

    const addSheet = (sheetName, headers, data) => {
      const MAX_SHEET_NAME_LENGTH = 31;
      const truncatedSheetName = sheetName.substring(0, MAX_SHEET_NAME_LENGTH);

      const worksheetData = [headers, ...data.map(row => headers.map(field => row[field] ?? ''))];
      const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

      const amountColIndex = headers.indexOf('Amount');
      if (amountColIndex !== -1) {
        for (let i = 1; i < worksheetData.length; i++) {
          const cellAddress = XLSX.utils.encode_cell({ c: amountColIndex, r: i });
          const cell = worksheet[cellAddress];
          if (cell && typeof cell.v === 'number') {
            cell.t = 'n';
            cell.z = '0.00';
          }
        }
      }

      XLSX.utils.book_append_sheet(workbook, worksheet, truncatedSheetName);
      }

    if (!allJournalEntries) return;

    const summaryHeaders = ['Date', 'Description', 'Amount'];
    const summaryData = Object.values(allJournalEntries).map(entry => ({
      Date: new Date(entry.journalEntryDate).toISOString().split('T')[0],
      Description: entry.journalEntryDescription || '',
      Amount: formatAmount(entry.amount)
    }));

    addSheet('Journal Entry Summary', summaryHeaders, summaryData);

    // Export the workbook
    XLSX.writeFile(workbook, `Journal_Entry_${this.props.selectedYear}_${this.props.selectedCurrency}.xlsx`);
  };

  getContextualMenuItems = () => {
    let menuItems = [];

    menuItems.push( {
      title: 'Add Journal Entry',
      icon: <AddCircleIcon />,
      onClick: () => {
        this.props.setCurrentPage(JOURNAL_ENTRY_PAGES.EDIT, {})
      }
    })

    menuItems.push( {
        title: 'Download as CSV',
        icon: <FileDownloadIcon />,
        onClick: () => {
          this.handleExport()
        }
      })

    if (this.props.loadingData) {
      menuItems.push({
        icon: <HourglassEmptyTwoTone />,
        handler: () => null,
        disabled: true,
        title: 'Loading data...',
      });
    }

    return menuItems;
  };

  render() {
    const currency = ['CAD', 'USD'];
    const {
      selectedCurrency,
      handleCurrencyChange,
      allJournalEntries,
      selectedYear,
      handleYearChange,
    } = this.props;

    return (
      <React.Fragment>
        <TopToolbar
          pageName={JOURNAL_ENTRY}
          menuItems={this.getContextualMenuItems()}
        />

        <Box className="box">
          <FormControl variant="outlined" className="form-control">
            <InputLabel id="year-label">Year</InputLabel>
            <Select
              className="select-year"
              labelId="year-label"
              value={selectedYear}
              onChange={handleYearChange}
              label="Year"
            >
              {this.props.years.map((year) => (
                <MenuItem key={year} value={year}>
                  {year}
                </MenuItem>
              ))}
            </Select>
          </FormControl>


          <FormControl variant="outlined" className="form-control">
            <InputLabel id="currency-label">Currency</InputLabel>
            <Select
              className="select"
              labelId="currency-label"
              value={selectedCurrency}
              onChange={handleCurrencyChange}
              label="Currency"
            >
              {currency.map((currency) => (
                <MenuItem key={currency} value={currency}>
                  {currency}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>


        <div className="table-page-journal-entry">
          <TablePage
            type="journalEntry"
            tableName="journalEntryTable"
            tableRows={allJournalEntries}
            tableColumnHeads={this.getTableHeaders()}
            tableRow={this.tableRow}
            paginationText="Summary per page"
            hasSearchField
            searchStrings={this.searchStrings}
          />
        </div>
      </React.Fragment>
    );
  }
}

export default JournalEntryTable;
